import { BlockFilledIcon, CheckCircleFilledIcon } from '@approvalmax/ui';
import { type BodyCellProps, Flex, Table, Text } from '@approvalmax/ui/src/components';
import { FC, memo } from 'react';

import type { UserRow } from '../../UserList.types';
import { messages } from './TFACell.messages';

const TFACell: FC<BodyCellProps<UserRow>> = memo((props) => {
    const { item } = props;

    return (
        <Table.Cell {...props}>
            <Flex alignItems='center' wrap={false} spacing='4'>
                {item.isTFAEnabled ? (
                    <>
                        <CheckCircleFilledIcon size={12} color='green100' />

                        <Text color='green100' font='label' wrap={false} fontSize='small'>
                            {messages.enabled}
                        </Text>
                    </>
                ) : (
                    <>
                        <BlockFilledIcon size={12} color='midnight60' />

                        <Text color='midnight60' font='label' wrap={false} fontSize='small'>
                            {messages.disabled}
                        </Text>
                    </>
                )}
            </Flex>
        </Table.Cell>
    );
});

export default TFACell;
